export default "__VITE_ASSET__46999471__"